import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import { Integrations } from "@sentry/tracing";

let sentryData = {
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
};

switch (process.env.SERVE_ENV) {
  case 'release':
    sentryData.dsn = 'https://ededed5094274383a5adb74379418218@smartvideomaker.xyz/7';
    break;
  case 'dev':
    sentryData.dsn = 'https://1f6bfa9a84cb4d2d916e9f4940155888@smartvideomaker.xyz/6';
    break;
}

if (sentryData.dsn) {
  Sentry.init(sentryData);
}


ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
